import { render, staticRenderFns } from "./PanelButtons.vue?vue&type=template&id=135b5332&"
import script from "./PanelButtons.vue?vue&type=script&lang=ts&"
export * from "./PanelButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports